var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26367 10.0352H11.4481V11.0352H1.26367V10.0352ZM1.26367 3.53516L6.35588 1.03516L11.4481 3.53516V5.53516H1.26367V3.53516ZM2.28211 4.15316V4.53516H10.4297V4.15316L6.35588 2.15316L2.28211 4.15316ZM6.35588 4.03516C6.22083 4.03516 6.09131 3.98248 5.99581 3.88871C5.90031 3.79494 5.84666 3.66776 5.84666 3.53516C5.84666 3.40255 5.90031 3.27537 5.99581 3.1816C6.09131 3.08783 6.22083 3.03516 6.35588 3.03516C6.49094 3.03516 6.62046 3.08783 6.71596 3.1816C6.81145 3.27537 6.8651 3.40255 6.8651 3.53516C6.8651 3.66776 6.81145 3.79494 6.71596 3.88871C6.62046 3.98248 6.49094 4.03516 6.35588 4.03516Z",
    fill: "#0D458A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.26953,
    y: 6.03467,
    width: 1.04075,
    height: 3.47964,
    fill: "#3AA64C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.79297,
    y: 6.03467,
    width: 1.04075,
    height: 3.47964,
    fill: "#3AA64C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.87891,
    y: 6.03467,
    width: 1.04075,
    height: 3.47964,
    fill: "#3AA64C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.40234,
    y: 6.03467,
    width: 1.04075,
    height: 3.47964,
    fill: "#3AA64C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.a7fb0a2777ccb53a6aeb03940952dacd.svg";
export { ForwardRef as ReactComponent };